import { initSplideCarousel } from "../../util/carousel";

const locationSplideOptions = {
  arrows: false,
  fixedWidth: "max-content",
  pagination: false,
  gap: "var(--column-gap)",
  breakpoints: {
    768: {
      perPage: 1,
      fixedWidth: "100%",
      gap: "var(--column-gap)",
      pagination: true,
    },
    1200: {
      perPage: 2,
      gap: "var(--column-gap)",
      pagination: true,
    },
  },
};

function init() {
  const sliders = document.querySelectorAll(
    ".js-location-carousel"
  ) as NodeListOf<HTMLElement>;

  for (const slider of sliders) {
    initSplideCarousel(slider, locationSplideOptions);
  }
}

export default init;
